/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row,
  Col,
  Label,
  Button,
  Alert,
  InputGroup,
  NavItem,
  NavLink,
  Nav,
  TabPane,
  TabContent,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post, put } from '../../helpers/api_helper';
import InventorySelector from '../Inventory/InventorySelector';
import KitSelector from '../Inventory/KitSelector';

function InternalOrderForm(props) {
  const {
    entity,
    t,
  } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [availableStock, setAvailableStock] = useState({});
  const [activeTab, setActiveTab] = useState('items');

  const fetchStockQty = async (id) => {
    try {
      const inv = await get(`/api/inventory/getByStockId/${id}`);
      if (inv && inv !== '') return inv.qty;
    } catch (e) {
      // ignore
    }
    try {
      const kit = await get(`/api/inventory/kit/stock/${id}`);
      if (kit && kit !== '') return kit.qty;
    } catch (e) {
      // ignore
    }
    return undefined;
  };

  const checkStockId = async (idx, value, setFieldError) => {
    if (!value) return;

    const qty = await fetchStockQty(value);
    if (qty === undefined) {
      setFieldError(`items.${idx}.stock_id`, t('Stock ID not found'));
    } else {
      setFieldError(`items.${idx}.stock_id`, undefined);
    }
    setAvailableStock((prev) => ({ ...prev, [value]: qty }));
  };

  useEffect(() => {
    const fetchAvailableStock = async () => {
      if (entity && entity.items && entity.items.length > 0) {
        const stockIds = entity.items.map((item) => item.stock_id);
        try {
          const results = await Promise.all(stockIds.map((id) => fetchStockQty(id)));
          const stockMap = {};
          results.forEach((qty, index) => {
            stockMap[stockIds[index]] = qty;
          });
          setAvailableStock(stockMap);
        } catch (error) {
          // ignore
        }
      }
    };
    fetchAvailableStock();
  }, [entity?.items]);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      setErrorMessage(null);
      let result;
      let failure = false;
      // Iterate the values and ensure all stock IDs are valid
      // Rewrite this iterator to be lightweight
      for (let i = 0; i < values.items.length; i += 1) {
        const item = values.items[i];
        // Make a request to validate the stock ID
        try {
          // eslint-disable-next-line no-await-in-loop
          const qty = await fetchStockQty(item.stock_id);
          if (qty === undefined) {
            failure = true;
            setErrorMessage(t(`No such stock ID: ${item.stock_id}`));
            break;
          }
        } catch (error) {
          failure = true;
          setErrorMessage(t(`No such stock ID: ${item.stock_id}`));
        }
      }

      if (!failure) {
        // If all stock IDs are valid, proceed with saving the order
        if (entity.id === undefined) {
          result = await post('/api/warehouse/internalOrders', values);
        } else {
          result = await put(`/api/warehouse/internalOrders/${entity.id}`, values);
        }

        toastr.success(t(`Order ID ${result.id} saved`), t('Success'));
        props.onSuccess(result);
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    type: Yup
      .string()
      .required(t('Type is required')),
    reference: Yup
      .string()
      .required(props.t(t('Reference is required'))),
    instructions: Yup
      .string()
      .nullable(),
    items: Yup.array().of(
      Yup.object().shape({
        stock_id: Yup.number().required(t('Stock ID is required')),
        qty: Yup.number().min(1, t('Quantity must be at least 1')),
      }),
    ),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          const vals = { ...values };

          vals.items = vals.items.map((item) => ({
            stock_id: item.stock_id.trim(),
            qty: item.qty,
          }));
          save(vals);
        }}
      >
        {({
          touched, errors, values, setFieldValue, setFieldError, handleBlur,
        }) => (
          <Form className="mt-3" id="InternalOrderForm" autoComplete="off">
            <Field type="hidden" name="type" />
            <div className="row mt-4 mb-4">
              <Label
                for="reference"
                className="col-sm-3 col-form-label"
              >
                {props.t('Reference')}
              </Label>
              <Col sm={9}>
                <Field className="form-control" name="reference" />
                <ErrorMessage
                  name="reference"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="instructions"
                className="col-sm-3 col-form-label"
              >
                {props.t('Delivery Instructions')}
              </Label>
              <Col sm={9}>
                <Field className="form-control" name="instructions" />
                <ErrorMessage
                  name="instructions"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="items"
                className="col-sm-3 col-form-label"
              >
                {props.t('Items')}
              </Label>
              <Col sm={9} className="pt-2">
                <FieldArray
                  name="items"
                  render={(arrayHelpers) => (
                    <div>
                      <Nav tabs className="mb-2">
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({ active: activeTab === 'items' })}
                            onClick={() => setActiveTab('items')}
                          >
                            {t('Items')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({ active: activeTab === 'kits' })}
                            onClick={() => setActiveTab('kits')}
                          >
                            {t('Kits')}
                          </NavLink>
                        </NavItem>
                      </Nav>

                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="items">
                          <InventorySelector onSelect={(itm) => {
                            const existingItemIndex = values.items.findIndex(
                              (item) => item.stock_id === itm.stock_id,
                            );
                            if (existingItemIndex !== -1) {
                              const updatedItems = [...values.items];
                              updatedItems[existingItemIndex].qty += 1;
                              setFieldValue(`items.${existingItemIndex}.qty`, updatedItems[existingItemIndex].qty);
                            } else if (itm.stock_id) {
                              arrayHelpers.push({ stock_id: itm.stock_id, qty: 1 });
                              checkStockId(arrayHelpers.length - 1, itm.stock_id, setFieldError);
                            }
                          }}
                          />
                        </TabPane>
                        <TabPane tabId="kits">
                          <KitSelector onSelect={(kit) => {
                            const existingItemIndex = values.items.findIndex(
                              (item) => item.stock_id === kit.stock_id,
                            );
                            if (existingItemIndex !== -1) {
                              const updatedItems = [...values.items];
                              updatedItems[existingItemIndex].qty += 1;
                              setFieldValue(`items.${existingItemIndex}.qty`, updatedItems[existingItemIndex].qty);
                            } else if (kit.stock_id) {
                              arrayHelpers.push({ stock_id: kit.stock_id, qty: 1 });
                              checkStockId(arrayHelpers.length - 1, kit.stock_id, setFieldError);
                            }
                          }}
                          />
                        </TabPane>
                      </TabContent>
                      <Button
                        type="button"
                        size="sm"
                        className="mb-3"
                        onClick={() => arrayHelpers.push({ stock_id: '', qty: 1 })}
                      >
                        {t('Add Item')}
                      </Button>
                      {values && values.items && values.items.length > 0 ? (
                        values.items.map((item, index) => (
                          <div key={index} className="mb-3 mt-3">
                            <div className="row">
                              <div className="col-4">
                                <label htmlFor={`items.${index}.stock_id`}>
                                  {t('Stock ID')}
                                </label>
                                <Field
                                  id={`items.${index}.stock_id`}
                                  name={`items.${index}.stock_id`}
                                  className="form-control"
                                  onBlur={(e) => {
                                    handleBlur(e);
                                    checkStockId(index, e.target.value, setFieldError);
                                  }}
                                />
                                <ErrorMessage
                                  name={`items.${index}.stock_id`}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                              <div className="col-4">
                                <label htmlFor={`items.${index}.stock_id`}>
                                  {t('Qty Available')}
                                </label>
                                <label className="form-control">
                                  {availableStock[item.stock_id] !== undefined ? availableStock[item.stock_id] : t('Loading...')}
                                </label>
                                <ErrorMessage
                                  name={`items.${index}.stock_id`}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                              <div className="col-4">
                                <label htmlFor={`items.${index}.qty`}>
                                  {t('Quantity')}
                                </label>
                                <InputGroup>
                                  <Field
                                    id={`items.${index}.qty`}
                                    name={`items.${index}.qty`}
                                    className="form-control"
                                  />
                                  <Button type="button" color="danger" className="btn-soft-danger" onClick={() => arrayHelpers.remove(index)}>
                                    <span className="mdi mdi-close-thick" />
                                  </Button>
                                </InputGroup>
                                <ErrorMessage
                                  name={`items.${index}.qty`}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                          </div>
                        ))
                      ) : null}
                    </div>
                  )}
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

InternalOrderForm.defaultProps = {
  entity: {
    reference: '',
    type: '',
    instructions: '',
    items: [],
  },
  onSuccess: () => {},
};

InternalOrderForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(InternalOrderForm));
